var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRpUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90446 4.92921L9.90854 7.00004H11.0834L11.0834 2.91671H7.00004V4.09154L9.07087 4.09562L2.91671 10.2498L3.75029 11.0834L9.90446 4.92921Z",
    fill: "#6EDB80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpUpArrow);
export default __webpack_public_path__ + "static/media/rp_up_arrow.7412adca50e71e85ea40a27bcca167e0.svg";
export { ForwardRef as ReactComponent };